<script>
  import AutoComplete from "simple-svelte-autocomplete";
  import { onMount } from 'svelte';

  export let apiPath = "";
  export let endpoint = "";
  export let suggestByTitle = false;
  export let locale = "de";
  export let targetUrl = "";
  export let mode = "checkbox";
  export let autoSubmit = false;
  let formTag;
  const allowedModes = ["checkbox", "radiobutton", "dropdown"];

  if (!allowedModes.includes(mode)) {
    mode = "checkbox";
  }

  export let classifications = [];
  export let locales = {};

  const translations = {
    de: {
      search: "Suchen",
      keywordSearch: "Stichwortsuche",
      noResultsText: "Keine Vorschläge vorhanden.",
      loadingText: "Ergebnisse werden geladen...",
      filterHeadline: "Ergebnisse filtern nach",
    },
    en: {
      search: "search",
      keywordSearch: "keyword search",
      noResultsText: "No suggestions found.",
      loadingText: "Loading results...",
      filterHeadline: "Filter results by",
    },
  };

  function getLocale(key) {
    if (key in locales) {
      return locales[key];
    }
    let legacyLocales;
    if (locale in translations) {
      legacyLocales = translations[locale];
    } else {
      legacyLocales = translations.en;
    }
    return legacyLocales[key] || "";
  }

  /* validate GET params */
  const searchParams = new URLSearchParams(location.search);

  let dcsearch = searchParams.get("dcsearch") ?? "";
  let selectedClassification = searchParams.get("selected") ?? "";

  if (selectedClassification) {
    const selectedFromParams = selectedClassification.split(",");
    if (selectedFromParams.length > 0) {
      classifications.map(
        (i) => (i.selected = selectedFromParams.includes(i._id))
      );
    }
  }

  const handleSubmit = (event) => {
    event.target.classList.add("is-loading");
    if (mode == "checkbox") {
      event.target.elements["selected"].value = [...classifications]
        .filter((c) => c.selected == true)
        .map((c) => c._id)
        .join(",");
    }
    event.target.submit();
  };

  const handleOptionChange = (_event) => {
    if (autoSubmit) {
      const submitButton = document.querySelector(
        ".dc-search-widget-form .submit input[type=submit]"
      );
      submitButton.click();
    }
  };

  async function getItems(keyword) {
    const url = suggestByTitle ? apiPath + "?suggestByTitle=1" : apiPath;
    let formData = new FormData();
    formData.append("search", keyword);
    formData.append("endpoint", endpoint);
    formData.append("classifications", selectedClassification);

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const json = await response.json();
    let res = json[0]["suggest"].map((search) => search.replaceAll("-", " "));
    const lc = res.map(item => item.toLowerCase());
    if (lc.indexOf(keyword.toLowerCase()) === -1) {
      res.unshift(keyword);
    }
    return res;
  }

  async function getChildCount(id) {
    const url = apiPath + "/count";

    let formData = new FormData();
    formData.append("search", dcsearch);
    formData.append("endpoint", endpoint);
    formData.append("classifications", id);

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const json = await response.json();
    let res = json["total"];
    return res;
  }

  // We cannot use the "onChange" event, since it fires too early. 
  onMount(() => {
    formTag.querySelector(".dc-search-suggest-input").addEventListener("keyup", (event) => {
      if (event.key === "Enter") {
        formTag.submit();
      }
    });
  });  

</script>

<form
  method="GET"
  class="dc-search-widget-form"
  action={targetUrl}
  on:submit|preventDefault={handleSubmit}
  bind:this={formTag}
>
  <AutoComplete
    searchFunction={getItems}
    delay="200"
    localFiltering="false"
    minCharactersToSearch="3"
    placeholder={getLocale("keywordSearch")}
    hideArrow="true"
    noResultsText={getLocale("noResultsText")}
    loadingText={getLocale("loadingText")}
    bind:selectedItem={dcsearch}
    name="dcsearch"
    className="dc-search-suggest"
    inputClassName="dc-search-suggest-input"
    dropdownClassName="dc-search-suggest-dropdown"
  />
  {#if mode == "checkbox"}
    <input type="hidden" name="selected" value="" />
  {:else}
    <input type="hidden" name="selected" value={selectedClassification} />
  {/if}

  <div class="submit">
    <input
      class="button"
      type="submit"
      value={getLocale("search")}
    />
  </div>
</form>
<div class="classification-container">
  <span class="sr-only">{getLocale("filterHeadline")}</span>
  {#if mode == "radiobutton"}
    <div class="classifications mode-{mode}">
      {#each classifications as child, i}
        <div class="checkbox-group {child.selected ? 'selected' : ''}">
          <input
            type="radio"
            id="c_{i}"
            value={child._id}
            bind:group={selectedClassification}
            on:change={handleOptionChange}
          />
          <label for="c_{i}"
            >{child.label}
            {#if child.count == undefined}
              {#await getChildCount(child._id)}
                <span></span>
              {:then count}
                <span class="badge">{child.count = count}</span>
              {:catch error}
                <span class="error"></span>
              {/await}
            {:else}
              <span class="badge">{child.count}</span>
            {/if}
          </label>
        </div>
      {/each}
    </div>
  {:else if mode == "dropdown"}
    <div class="classifications mode-{mode}">
      <select bind:value={selectedClassification}>
        {#each classifications as child}
          <option value={child._id}>
            {child.label}
            {#if child.count == undefined}
              {#await getChildCount(child._id)}
                <span></span>
              {:then count}
                <span class="badge">{child.count = count}</span>
              {:catch error}
                <span class="error"></span>
              {/await}
            {:else}
              <span class="badge">{child.count}</span>
            {/if}
          </option>
        {/each}
      </select>
    </div>
  {:else}
    <div class="classifications mode-{mode}">
      {#each classifications as child, i}
        <div class="checkbox-group {child.selected ? 'selected' : ''}">
          <input
            type="checkbox"
            id="c_{i}"
            value={child._id}
            bind:checked={child.selected}
            on:change={handleOptionChange}
          />
          <label for="c_{i}"
            >{child.label}
            {#if child.count == undefined}
              {#await getChildCount(child._id)}
                <span></span>
              {:then count}
                <span class="badge">{child.count = count}</span>
              {:catch error}
                <span class="error"></span>
              {/await}
            {:else}
              <span class="badge">{child.count}</span>
            {/if}
          </label>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
</style>
